import { createMapAction } from "chalet-shared";

import { Flag, Store } from "../reducers/persist";

export const actionCreators = {
    toggleFlag: createMapAction("TOGGLE_FLAG", (x: Flag) => x),
    storeObject: createMapAction("STORE_OBJECT", (x: Partial<Store>) => x),
};
